import React, { useState } from 'react';
import styles from './LoginPage.css';
import { ClickElement, InputField } from '../form';
import { userLogin } from '../../apis/user';
import { useDispatch } from 'react-redux';
import { userLoginAction, userLogoutAction, UserState, userStateAction } from '../../ducks';
import { LOGINPAGE } from '../../lib/labels';
import { settings } from '../../settings';

export const LoginForm = ({ isLoading }) => {

  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const submit = async e => {
    e.preventDefault();
    setError(null);
    dispatch(userStateAction(UserState.PENDING));
    try {
      const data = await (await userLogin({ username: email.toLowerCase(), password })).json();
      dispatch(data.success ? userLoginAction({
        username: data.user.username,
        isLoggedIn: true,
        isPremium: false,
      }) : userLogoutAction());
      if (!data.success) {
        if (data.message==='account not confirmed') {
          setError(LOGINPAGE.LOGIN_FORM.ERROR_UNCONFIRMED);
        } else { 
          setError(LOGINPAGE.LOGIN_FORM.ERROR); //other messages: user not found / wrong password
        }
      }
    } catch (error) {
      setError(error.message);
      dispatch(userLogoutAction());
    }
  };

  return (
    <form onSubmit={submit}>
      <div className="indent">
        <InputField
          name={LOGINPAGE.LOGIN_FORM.EMAIL_LABEL}
          type="email"
          placeholder={LOGINPAGE.LOGIN_FORM.EMAIL_PLACEHOLDER}
          autoComplete="off"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          label
          disabled={isLoading}
        />
        <InputField
          name={LOGINPAGE.LOGIN_FORM.PASSWORD_LABEL}
          type="password"
          placeholder={LOGINPAGE.LOGIN_FORM.PASSWORD_PLACEHOLDER}
          autoComplete="off"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
          label
          disabled={isLoading}
        />
        <div className={styles.form_options}>
          <a
            href={`${settings.USER_HOST}/user/forgot-password`}
            rel="noopener noreferrer"
            target="_blank"
          >{LOGINPAGE.LOGIN_FORM.FORGOT_PASSWORD}</a>          
          <a
            href={`${settings.USER_HOST}/contact`}
            rel="noopener noreferrer"
            target="_blank"
          >{LOGINPAGE.LOGIN_FORM.PROBLEMS}</a>
        </div>
        {error !== null && (
          <p className={styles.error}>{error}</p>
        )}
        {isLoading && (
          <p>{LOGINPAGE.LOGIN_FORM.LOADING_TEXT}</p>
        )}
      </div>
      <ClickElement
        primary
        ElementType="button"
        type="submit"
        text={LOGINPAGE.LOGIN_FORM.BUTTON}
        disabled={isLoading}
      />
    </form>
  );
};
